import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal';
import styles from './approvalPopup.module.scss';
import CommonTextField from '../../../Components/TextField/textField';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import UseAxios from '../../../Api/http/http';
import { postEffortApproval } from '../../../Api/request/approval';

const AddApproval = ({ isEffortPopup = false, approvalId, userId, modalOpen, handleClose, updatedData }) => {
  const [descriptionValue, setDescriptionValue] = useState('');
  const { snackbarOpen } = useSnackbar();

  const handleDescriptionChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length <= 250) {
      setDescriptionValue(newValue);
    }
  };

  const handleCloseResetValues = () => {
    setDescriptionValue('');
    handleClose();
  };

  const handleApprove = async () => {
    try {
      if (isEffortPopup) {

        const payload = {
          id: approvalId,
          user_id: userId,
          status: 'APPROVED',
          comment: descriptionValue,
        };
        // Approve Efforts
        await UseAxios(postEffortApproval(payload));
        snackbarOpen('Approved deal efforts', 'success');
      }
      updatedData();
      handleCloseResetValues();
    } catch (error) {
      console.error('Error adding approval:', error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };

  const handleReject = async () => {
    try {
      if (isEffortPopup) {
        const payload = {
          id: approvalId,
          user_id: userId,
          status: 'REJECTED',
          comment: descriptionValue,
        };
        // Reject Efforts
        await UseAxios(postEffortApproval(payload));
        snackbarOpen('Rejected deal efforts', 'success');
      }
      updatedData();
      handleCloseResetValues();
    } catch (error) {
      console.error('Error rejecting approval:', error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };

  return (
    <FormDialog
      open={modalOpen}
      handleClose={handleCloseResetValues}
      title='Add Approval Comment'
      dialogPaperCss={styles['add-approval-paper']}
      dialogCss={styles['add-approval-dialog']}
      dialogBodycontent={
        <div className={styles['add-approval-dialog-body']}>
          <CommonTextField
            textCss={styles['add-approval-description']}
            label='Add Comment'
            value={descriptionValue}
            onChange={handleDescriptionChange}
            placeholder='Add Comment.'
            size="small"
            id="add-description-text"
            multiline
            rows={4}
          />
        </div>
      }
      button1='Reject'
      cancelButtonId="reject-approval-btn"
      button1Action={handleReject}
      button2={isEffortPopup ? 'Approve Efforts' : 'Financial Approve'}
      submitButtonId="add-approval-btn"
      button2Action={handleApprove}
    />
  );
};

AddApproval.propTypes = {
  approvalId: PropTypes.number, // id for which the approval is to be done
  userId: PropTypes.number, // user id of the logged in user
  isEffortPopup: PropTypes.bool,
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  updatedData: PropTypes.func,
};

export default AddApproval;
